<template>
 <div class="bg-primary vh-100 shadow-lg overflow-scroll">
  <ul class="sidebar">
    <li class="main-brand text-center sticky-top">
      <RouterLink to="/">
          <h3 class="fw-bold my-1">Dashboard</h3>
      </RouterLink>
    </li>
    <li class="p-2"></li>
    <Sideli title="Home" link-name="/" icon-name="fa-home"></Sideli>
    <Sideli title="About" link-name="about" icon-name="fa-list"></Sideli>

    <MenuLi title="Category Management"></MenuLi>
    <Sideli title="Create Category" link-name="category-create" icon-name="fa-square-plus"></Sideli>
    <Sideli title="Category Lists" link-name="category-lists" icon-name="fa-list" noti-count="2" ></Sideli>

    <MenuLi title="Product Management"></MenuLi>
    <Sideli title="Today Orders" link-name="about" icon-name="fa-cart-arrow-down"></Sideli>
    <Sideli title="Data Analysis" link-name="Data-Analysis" icon-name="fa-chart-pie"></Sideli>

    <MenuLi title="Item Management"></MenuLi>
    <Sideli title="Recent Items" link-name="about" icon-name="fa-chart-line"></Sideli>
    <Sideli title="Create New Item" link-name="about" icon-name="fa-circle-plus"></Sideli>
    <Sideli title="Item Lists" link-name="about" icon-name="fa-bars-progress" noti-count="5"></Sideli>

    <MenuLi title="User Management"></MenuLi>
    <Sideli title="Create User" link-name="about" icon-name="fa-user-plus"></Sideli>
    <Sideli title="Manage User" link-name="about" icon-name="fa-user-group"></Sideli>
    <Sideli title="Baned User" link-name="about" icon-name="fa-user-minus"></Sideli>
    <Sideli title="User Analysis" link-name="about" icon-name="fa-user-gear"></Sideli>

    <li class="menu-title ms-2 p my-2 fw-bold text-uppercase">Product Manager</li>
    <Sideli title="Today Orders" link-name="about" icon-name="fa-list"></Sideli>
    <Sideli title="Data Analysis" link-name="about" icon-name="fa-list"></Sideli>

  </ul>
 </div>
</template>

<script>
import Li from "@/components/small_layouts/Li";
import Sideli from "@/components/small_layouts/Sideli";
import MenuLi from "@/components/small_layouts/MenuLi";
export default {
  name: "Sidebar",
  components: {MenuLi, Sideli, Li}
}
</script>

<style scoped>
  .main-brand{
    background: #7386D5;
  }
  .sidebar{
    color: #fff;
    padding-left: 0 !important;
  }
  .sidebar li{
    list-style: none;
  }
  .sidebar li a{
    padding: 10px;
    text-decoration: none;
    color: #ffffff;
    display: block;
    font-size: 1.1em !important;

  }
  .sidebar ul li a:hover {
    color: #7386D5;
    background: #f5f5f5;
  }
  .sidebar ul li a.active{
    color: #ffffff;
    background: #5268c2;
  }
</style>